module.exports = __webpack_public_path__ + "img/cx.0d9e9654.svg";